module.exports = __webpack_public_path__ + "ed2b1df6035f20c55e6bcb0e575bea8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_ORK_W_639px_H_660px.jpg
// module id = 396
// module chunks = 0